import React, { createContext } from 'react';

const LoadingContext = React.createContext({
    isLoading: false,
    setIsLoading: (isLoading: boolean, context: string) => {},
});

export default LoadingContext;
